import * as React from 'react';
import { classNames } from '~/utils/classNames';

type Variant = 'primary' | 'secondary' | 'warning' | 'danger' | 'info';

interface LabelBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: Variant;
}

const baseClasses =
  'inline-flex items-center rounded-full border border-bolt-ds-borderOutline px-2.5 py-0.5 text-xs font-semibold transition-colors focus-visible:outline-2';

const variantClasses: Record<Variant, string> = {
  primary: 'border-transparent bg-bolt-ds-brand text-bolt-ds-textPrimary hover:bg-bolt-ds-brand/80',
  secondary: 'border-transparent bg-bolt-ds-surfaceOne text-bolt-ds-textSecondary hover:bg-bolt-ds-surfaceOne/80',
  warning: 'border-transparent bg-bolt-ds-warningContainer text-bolt-ds-warning hover:bg-warning/80',
  danger: 'border-transparent bg-bolt-ds-dangerContainer text-bolt-ds-danger hover:bg-danger/80',
  info: 'text-bolt-ds-textPrimary',
};

export const LabelBadge = ({ className, variant = 'primary', ...props }: LabelBadgeProps) => {
  return <div className={classNames(baseClasses, variantClasses[variant], className)} {...props} />;
};
